export function initSlider (sliderElement, minValue, maxValue, initialValue) {
  if (sliderElement) {
    const slider = sliderElement

    // set min and max value
    slider.min = minValue
    slider.max = maxValue
    slider.value = initialValue  // set initial value

    // Add the event listener
    addSliderListener(slider, minValue, maxValue)

    // Initial calculation and setting of the background position
    const initialBackgroundPositionX = calculateBackgroundPositionX(slider, initialValue, minValue, maxValue)
    slider.style.backgroundPositionX = initialBackgroundPositionX
  }
}

// Function to calculate background position
export function calculateBackgroundPositionX (sliderElem, value, minValue, maxValue) {
  if (sliderElem) {
    // Get the dimensions of the slider
    const sliderRect = sliderElem.getBoundingClientRect()

    if (value < minValue) {
      return sliderRect.width + 'px'
    } else if (value > maxValue) {
      return '0px'
    } else {
      const posLeft = (value - minValue) / (maxValue - minValue)
      return sliderRect.width * posLeft + (-1 * sliderRect.width) + 'px'
    }
  } else {
    return '0px'
  }
}

// Event listener for the slider
function addSliderListener (sliderElem, minValue, maxValue) {
  sliderElem.addEventListener('input', function () {
    const value = sliderElem.value

    // Calculate the new background position
    const backgroundPositionX = calculateBackgroundPositionX(sliderElem, value, minValue, maxValue)

    // Set the calculated background position
    sliderElem.style.backgroundPositionX = backgroundPositionX
  })
}
